
export const Loader = () => {
  return (
    <div className="h-full animate-pulse bg-gray-300"></div>
  )
}
